<!-- @veltra/icons generated sha256:fa11df81a42e4778 gen:8 source:src/svg/normal/close.svg -->
<script setup lang="ts">
defineOptions({ name: 'Close' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m8 9.265 3.602 3.603a.9.9 0 0 0 1.27-.006.897.897 0 0 0-.004-1.26L9.266 8l3.602-3.602a.9.9 0 0 0-.005-1.27l-.015-.014c-.35-.35-.896-.331-1.246.018L8 6.735 4.398 3.132a.9.9 0 0 0-1.27.005.897.897 0 0 0 .004 1.26L6.735 8l-3.603 3.602c-.35.35-.368.897-.018 1.246l.014.014a.9.9 0 0 0 1.27.006z"
    />
  </svg>
</template>
